var BufferInputView = require('bufferinputview');
var BufferNickView = require('buffernickview');
var BufferScrollView = require('bufferscrollview');
var ConnectionStatusView = require('connectionstatusview');
var LowerChatterBarView = require('lowerchatterbarview');
var OverlayContainerView = require('overlaycontainerview');
var UpperChatterBarView = require('upperchatterbarview');
var BufferUploadView = require('bufferuploadview');
var BufferFormatter = require('bufferformatter');
var SelectionCopy = require('../selection-copy.es6').default;
var perf = require('../../lib/perf.es6');
var Keyboard = require('../../lib/keyboard.es6').default;


var BufferView = Backbone.View.extend({
    tagName: 'div',
    className: 'buffercontainer buffercontainer--hidden',
    id: function () {
        return 'buffercontainer_' + this.model.bid();
    },
    status: null,
    initialize: function (options) {
        this.buffer = options.buffer || this.model;
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        this.model.on('selectedChange', this.renderSelected, this);
        this.model.on('doneSelected', this.doneSelected, this);
        this.buffer.on('remove', this.remove, this);
        this.listenTo(this.model.session, 'buffersShown', this.buffersShown);

        this.upperChatter = new UpperChatterBarView(options);
        this.lowerChatter = new LowerChatterBarView(options);
        this.connectionStatus = new ConnectionStatusView(options);

        // Set in sub views
        this.status.on('topChange', this.mainTopChange, this);

        this.scroll = new BufferScrollView(options);
        this.scroll.on('topChange', this.scrollTopChange, this);
        this.scroll.on('heightChange', this.scrollHeightChange, this);
        this.scroll.on('widthChange', this.scrollWidthChange, this);

        if (!this.model.isThread()) {
            this.nick = new BufferNickView(options);
        }
        this.input = new BufferInputView(options);
        this.input.on('focus', this.inputFocus, this);
        this.input.on('blur', this.inputBlur, this);
        this.input.on('key', this.inputKey, this);
        this.selectionCopy = new SelectionCopy(options, this);
        if (this.model.session.uploadsEnabled()) {
            this.upload = new BufferUploadView(options, this.input);
        }

        this.overlay = new OverlayContainerView({
            model: this.model,
            session: this.model.session
        });

        this.renderInlineFiles(true);
        this.buffer.on('prefChange:files-disableinline', function () {
            this.renderInlineFiles();
        }, this);
        this.renderInlineAttachments(true);
        this.buffer.on('prefChange:attachments-disableinline', function () {
            this.renderInlineAttachments();
        }, this);
        this.renderInlinePastes(true);
        this.buffer.on('prefChange:pastebin-disableinline', function () {
            this.renderInlinePastes();
        }, this);
        this.renderInlineSocialMedia(true);
        this.buffer.on('prefChange:twitter-disableinline', function () {
            this.renderInlineSocialMedia();
        }, this);
        this.renderInlineMastodon(true);
        this.buffer.on('prefChange:mastodon-enableinline', function () {
            this.renderInlineMastodon();
        }, this);
        this.renderInlineBsky(true);
        this.buffer.on('prefChange:bsky-enableinline', function () {
            this.renderInlineBsky();
        }, this);
        this.renderInlineReddit(true);
        this.buffer.on('prefChange:reddit-enableinline', function () {
            this.renderInlineReddit();
        }, this);
        this.renderInlineImages(true);
        this.buffer.on('prefChange:inlineimages', function () {
            this.renderInlineImages();
            this.renderAvatars();
            this.renderShowAvatarPrompt();
        }, this);
        this.renderMultiline(true);
        this.buffer.on('prefChange:chat-oneline', function () {
            this.renderMultiline();
            this.renderRealnames();
            this.renderTimestamp();
        }, this);
        this.renderRealnames(true);
        this.buffer.on('prefChange:chat-norealname', function () {
            this.renderRealnames();
        }, this);
        this.renderColor(true);
        this.buffer.on('prefChange:chat-nocolor', function () {
            this.renderColor();
        }, this);
        this.renderTimestamp(true);
        this.buffer.on('prefChange:time-left', function () {
            this.renderTimestamp();
        }, this);
        this.renderAvatars(true);
        this.buffer.on('prefChange:avatars-off', function () {
            this.renderAvatars();
            this.renderTimestamp();
            this.renderShowAvatarPrompt();
        }, this);
        this.buffer.on('prefChange:avatars-image-off', function () {
            this.renderAvatars();
            this.renderShowAvatarPrompt();
        }, this);
        this.renderShowAvatarPrompt();
        this.listenTo(this.model.connection, 'change:avatars_supported', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'prefChange:avatars-disableUploadPrompt', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'change:ircserver', this.renderShowAvatarPrompt);
        this.listenTo(this.model.connection, 'change:hostname', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:avatar', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:avatar_url', this.renderShowAvatarPrompt);
        this.listenTo(this.model.getUser(), 'change:usermask', this.renderShowAvatarPrompt);
        this.model.on('reactMessageEmoji', this.reactMessageEmoji, this);
        this.model.on('lockReplyHighlight', this.lockReplyHighlight, this);
        this.model.on('clearReplyHighlight', this.clearReplyHighlight, this);
        this.model.on('focusInput', this.focusInput, this);

        this.throttledSendTyping = _.throttle(
            _.bind(this.sendTyping, this), 3000, {trailing: false}
        );
    },
    events: {
        'click .bufferBelowExtras .extrasBar': 'clickLowerChatter',
        'click .bufferAboveExtras .extrasDismiss': 'clickDismiss',
        'click .bufferAboveExtras .extrasBar': 'clickUpperChatter',
        'mouseenter .reply__indicator, .reply__quote': 'hoverReply',
        'mouseleave .reply__indicator, .reply__quote': 'unhoverReply',
        'click .reply__indicator': 'clickReply',
        'buttonClick .reply__add': 'clickReply',
        'click .reply__summary': 'clickReply',
        'click .reply__quote': 'clickReply',
        'autogrow': 'autogrowInput',
        'click .uploadcell': 'clickUpload',
        'buttonClick .uploadcell': 'clickUpload',
        'click .emojicell': 'clickEmoji',
        'buttonClick .emojicell': 'clickEmoji'
    },
    reactMessageEmoji: function (colon, data) {
        this.model.react(data.message.getMsgId(), emoji.replace_colons(colon, true));
    },
    focusInput: function () {
        this.input.focus();
    },
    inputFocus: function () {
        this.$el.addClass('focus');
    },
    inputBlur: function () {
        this.$el.removeClass('focus');
    },
    inputKey: function (e) {
        if (e.which == Keyboard.KEYS.PAGE_UP) {
            if (!e.metaKey && !e.ctrlKey) {
                this.scroll.scrollUp();
            }
            return;
        } else if (e.which == Keyboard.KEYS.PAGE_DOWN) {
            if (!e.metaKey && !e.ctrlKey) {
                this.scroll.scrollDown();
            }
            return;
        } else if (e.which == Keyboard.KEYS.END) {
            if (!this.input.val()) {
                if (!e.metaKey && !e.ctrlKey) {
                    this.scroll.scrollToBottom();
                }
                return;
            }
        } else if (e.which == Keyboard.KEYS.HOME) {
            if (!this.input.val()) {
                if (!e.metaKey && !e.ctrlKey) {
                    this.scroll.scrollToTop();
                }
                return;
            }
        } else if (e.which == Keyboard.KEYS.ENTER) {
            // Never just submit the form on enter
            e.preventDefault();
            this.input.onEnter(e);
        }
        this.input.tabComplete.onKey(e);
    },
    clickDismiss: function (e) {
        e.preventDefault();
        this.model.read();
    },
    clickUpperChatter: function (e) {
        e.preventDefault();
        if (!this.scroll.isLastSeenMessageRendered()) {
            this.scroll.scrollToTop();
            this.scroll.setScrolledToBottom(false);
            this.scroll.loadOrRenderBacklog();
        } else {
            this.scroll.scrollToLastSeenOrTop();
        }
    },
    clickLowerChatter: function (e) {
        e.preventDefault();
        this.scroll.log.renderBelowScroll();
        if (e.altKey) {
            this.scroll.scrollToBottom();
        } else {
            this.scroll.scrollToBottomSeenOrBottom();
        }
    },
    autogrowInput: function (e, css) {
        this.scroll.checkPinBottom(function (pinBottom) {
            $(e.target).css(css);
            this.scroll.onChange(pinBottom);
        }, this, { checkRecent: true });
    },

    fullLayoutChange: function (pinBottom) {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.onScrollChange(pinBottom);
        this.scrollTopChange();
        this.scrollWidthChange(pinBottom);
    },
    mainTopChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.scroll.checkPinBottom(function (pinBottom) {
            this.scrollTopChange();
            this.scroll.fixScroll(pinBottom);
        }, this);
    },
    scrollTopChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
        this.scrollHeightChange();
    },
    scrollHeightChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.uncacheRect();
    },
    scrollWidthChange: function (pinBottom) {
        if (!this.isVisible()) {
            return;
        }
        this.trigger('timeLayoutChange');
        this.scroll.widthChange(pinBottom);
    },

    onScrollChange: function (pinBottom, forceRead) {
        if (!this.isVisible()) {
            return;
        }
        if (this.scroll.isFetching()) {
            return;
        }
        var upperRows = this.scroll.log.getRowAtTopOfScroll();
        if (!this.model.isThread()) {
            var upperMessage = this.scroll.getMessageForRow(upperRows[0]);
            var lowerMessage = this.scroll.getMessageAtBottomOfScroll();

            // Update chatter bars
            var upperVisible = this.upperChatter.isVisible();
            var upperShown = this.upperChatter.update(upperMessage);
            if (upperShown === false) {
                // No chatter bar and focused
                if (forceRead || this.model.session.isFocused()) {
                    this.model.read();
                }
            }

            var lowerVisible = this.lowerChatter.isVisible();
            var bottomSeenRow = this.scroll.log.getBottomSeen();
            var bottomSeenDate = this.lowerChatter.update(lowerMessage, bottomSeenRow);
            if (bottomSeenDate) {
                // Updated
                bottomSeenRow.data('locked-time', bottomSeenDate.getTime());
            }

            var fixScroll = false;
            if (upperVisible != this.upperChatter.isVisible()) {
                // Toggled state
                this.scrollTopChange();
                fixScroll = true;
            } else if (lowerVisible != this.lowerChatter.isVisible()) {
                this.scrollHeightChange();
                fixScroll = true;
            }

            if (fixScroll || this.scroll.isResizing()) {
                // Fix scroll position in case chatter bar toggling shifted scroll
                this.scroll.fixScroll(pinBottom);
            }

            // Update scroll clock
            var clockShown = this.scroll.updateClock(upperMessage);
            this.$el.toggleClass('clockShown', clockShown);
        }
        this.scroll.setStickyAuthor(upperRows);
    },
    // This will get called from MainAreaView
    renderOverlay: function (overlay) {
        this.overlay.append(overlay);

        return this;
    },
    hoverUserRows: function (user) {
        var attr = '[data-usermask="' + this.formatter.escapeQuerySelector(user.getHostMask()) + '"]';
        this.scroll.log.$('div.row .bufferLink' + attr + ', div.row' + attr).addClass('hover');
    },
    unhoverUserRows: function () {
        this.scroll.log.$('div.row, div.row .bufferLink').removeClass('hover');
    },
    renderMultiline: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('multiline', this.buffer.multiline());
            this.$el.toggleClass('oneline', !this.buffer.multiline());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderRealnames: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('realnames-on', this.buffer.showRealnames());
            this.$el.toggleClass('realnames-off', !this.buffer.showRealnames());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderColor: function (initial) {
        this.$el.toggleClass('irccolors', this.buffer.formatColor());
    },
    renderTimestamp: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('time-right', this.buffer.isTimeRight());
            this.$el.toggleClass('time-left', !this.buffer.isTimeRight());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderAvatars: function (initial) {
        this.scroll.checkPinBottom(function (pinBottom) {
            this.$el.toggleClass('avatars-on', this.buffer.avatarsEnabled());
            this.$el.toggleClass('avatars-off', !this.buffer.avatarsEnabled());
            this.$el.toggleClass('avatars-image-on', this.buffer.imageAvatarsEnabled());
            this.$el.toggleClass('avatars-image-off', !this.buffer.imageAvatarsEnabled());
            this.$el.toggleClass('avatars-external', this.buffer.embedExternalAvatars());
            this.$el.toggleClass('avatars-noexternal', !this.buffer.embedExternalAvatars());
            if (!initial) {
                this.scroll.onChange(pinBottom);
            }
        }, this);
    },
    renderShowAvatarPrompt: function () {
        this.$el.toggleClass('avatars-uploadssupported', this.model.connection.avatarUploadsSupported());
        this.$el.toggleClass('avatars-showuploadprompt', this.model.shouldPromptAvatar());
    },
    renderInlineFiles: function (initial) {
        this.$el.toggleClass('inlinefiles', this.buffer.inlineFilesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineFilesAllowed()) {
                    this.scroll.log.loadFiles($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineAttachments: function (initial) {
        this.$el.toggleClass('inlineattachments', this.buffer.inlineAttachmentsAllowed());
        if (!initial) {
            this.scroll.onChange();
        }
    },
    renderInlinePastes: function (initial) {
        this.$el.toggleClass('inlinepastes', this.buffer.inlinePastesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                this.scroll.log.loadAttachmentSnippets($(this.scroll.log.el));
                if (this.buffer.inlinePastesAllowed()) {
                    this.scroll.log.loadPastes($(this.scroll.log.el));
                    this.scroll.log.loadGists($(this.scroll.log.el));
                    this.$('i.iframeEmbed.pastebincom').each(_.bind(function (i, el) {
                        this.replaceEmbedPlaceholder(el);
                    }, this));
                    this.scroll.log.loadEmbedIframes($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineSocialMedia: function (initial) {
        this.$el.toggleClass('inlineSocialMedia', this.buffer.inlineSocialMediaAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineSocialMediaAllowed()) {
                    this.scroll.log.loadTweets($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineMastodon: function (initial) {
        this.$el.toggleClass('inlineMastodon', this.buffer.inlineMastodonAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineMastodonAllowed()) {
                    this.scroll.log.loadMastodon($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineBsky: function (initial) {
        this.$el.toggleClass('inlineBsky', this.buffer.inlineBskyAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineBskyAllowed()) {
                    this.scroll.log.loadBsky($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderInlineReddit: function (initial) {
        this.$el.toggleClass('inlineReddit', this.buffer.inlineRedditAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineRedditAllowed()) {
                    this.scroll.log.loadReddit($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    replaceEmbedPlaceholder: function (el) {
        var attrs = ['class', 'src', 'width', 'height', 'alt'];
        var tag;
        if ($(el).hasClass('image')) {
            tag = 'img';
        } else {
            tag = 'iframe';
            attrs = attrs.concat(Object.keys(this.formatter.linker.iframeProps()));
        }
        var replacement = $('<' + tag + '>');
        _.each(attrs, function (attr) {
            replacement.attr(attr, $(el).attr(attr));
        });
        $(el).replaceWith(replacement);
    },
    renderInlineImages: function (initial) {
        this.$el.toggleClass('inlineimages', this.buffer.inlineImagesAllowed());
        if (!initial) {
            this.scroll.checkPinBottom(function (pinBottom) {
                if (this.buffer.inlineImagesAllowed()) {
                    this.$('i.image, i.iframeEmbed.video, i.iframeEmbed.spotify, i.iframeEmbed.garmin, i.iframeEmbed.tenor').each(_.bind(function (i, el) {
                        this.replaceEmbedPlaceholder(el);
                    }, this));
                    this.scroll.log.inlineImages($(this.scroll.log.el));
                }
                this.scroll.onChange(pinBottom);
            }, this);
        }
    },
    renderActive: function () {
        this.$el.toggleClass('active', this.model.isActive());
        if (this.model.isSelected()) {
            this.mainTopChange();
        }
        return this;
    },
    renderAway: function () {
        this.$el.toggleClass('away', this.model.connection.isAway());
    },
    renderSlack: function () {
        this.$el.toggleClass('slack', this.model.connection.isSlack());
        this.$el.toggleClass('slack--oauth', this.model.connection.isSlackOAuth());
    },
    renderSelected: function () {
        if (this.model.isSelected()) {
            this.show();
        } else {
            this.hide();
        }

        return this;
    },
    doneSelected: function () {
        // Timing
        var metadata = {
            messages: this.model.messages.length
        };
        if (this.model.isChannel()) {
            metadata.members = this.model.members.length;
        }
        var baseKey = 'bufferSelect';
        var key = (this.firstRender ? 'init' : '') + baseKey;
        this.model.session.perfMeasure(key, this.model.bid(), metadata, perf.measure(baseKey));
        this.firstRender = false;
    },
    userTyping: function () {
        this.renderInputStatus();
    },
    sendTyping: function (value) {
        this.model.sendTyping(value);
    },
    renderInputStatus: function (event) {
        var val = this.input.val();

        var slash = this.input.isSlashCommand(val);
        if (
            event && event.type == 'input' &&
            val &&
            !slash &&
            this.model.connection.hasClientTags() &&
            !this.model.connection.blocksTyping() &&
            !this.model.isThread() &&
            !this.model.isServerLog() &&
            this.model.isSharingTyping() &&
            this.model.connection.isConnected() &&
            this.model.isActive() &&
            this.model.session.isStreamConnected()
        ) {
            this.throttledSendTyping('active');
        }

        // Toggle nick if slash command
        var showNick = !this.model.isThread() && !slash;
        if (this.nickBoxShown != showNick) {
            this.nickInputBox.toggleClass('hideNick', !showNick);
            this.nickBoxShown = showNick;
        }

        var sentence = '';
        if (val.indexOf('\n') === -1) {
            var charsRemaining = this.input.calculateLineLengthRemaining(val);
            if (charsRemaining < 20) {
                sentence += '<span class="inputstatus_charsLeft">';
                if (charsRemaining < 0) {
                    if (charsRemaining > -20) {
                        sentence += charsRemaining + ' – ';
                    }
                    sentence += 'message will be split';
                } else {
                    sentence += charsRemaining + ' ' +
                        this.formatter.pluralise(charsRemaining, 'character') + ' left';
                }
                sentence += '</span> ';
            }
        }

        var typers = this.model.getTypers();
        if (typers.length) {
            var typersList;
            if (typers.length > 5) {
                typersList = typers.length + ' people';
            } else {
                typersList = this.formatter.escapeText(
                    this.formatter.listSentence(_.invoke(typers, 'getDisplayName'))
                );
            }
            sentence += '<span class="inputstatus_typers">' +
                typersList + ' ' + this.formatter.pluralise(typers.length, 'is', 'are') + ' typing' +
                '</span>';
        }
        this.$('.inputstatuscell').html(sentence);
    },
    renderConnectionStatus: function (initial) {
        if (initial) {
            this.connectionStatus.render();
        } else {
            this.scroll.checkPinBottom(function (pinBottom) {
                this.connectionStatus.render();
                this.scrollHeightChange();
                this.scroll.fixScroll(pinBottom);
            }, this);
        }
        return this.connectionStatus;
    },
    buffersShown: function () {
        if (this.model.isSelected()) {
            this.afterShow(true);
        }
    },
    afterShow: function (force) {
        if (force) {
            $('#bufferPanes').addClass('show');
        } else {
            $('#bufferPanes.canShow').addClass('show');
        }
        this.visible = true;
        this.scroll.checkPinBottom(function (pinBottom) {
            this.fullLayoutChange(pinBottom);
            this.scroll.fixScroll(pinBottom);
        }, this);
        this.model.trigger('afterShow');
    },
    show: function () {
        this.$el.removeClass('buffercontainer--hidden');

        this.render();

        this.afterShow();

        this.onInput();

        return this;
    },
    updateLastSeen: function () {
        if (!this.model.isDeferred() && !this.model.hasUnseen()) {
            this.scroll.log.renderLastSeen();
        }
    },
    isVisible: function () {
        return this.visible;
    },
    hide: function () {
        this.visible = false;
        $('#bufferPanes').removeClass('show');
        this.$el.addClass('buffercontainer--hidden');
        this.updateLastSeen();
        this.unhoverUserRows();

        return this;
    },
    renderLastSeen: function () {
        if (this.model.isSelected()) {
            if (!this.model.hasUnseen()) {
                if (this.upperChatter.hide()) {
                    this.scrollTopChange();
                }
                // Unlock focus and bottom seen if they're lower than this id
                // This can happen when we get a heartbeat from another socket
                var focusSeenId = this.model.eid(this.model.getFocusSeen());
                var change;
                if (focusSeenId && this.model.getLastSeen() > focusSeenId) {
                    this.scroll.unlockFocusSeen();
                    change = true;
                }
                var bottomSeenId = this.model.eid(this.model.getBottomSeen());
                if (bottomSeenId && this.model.getLastSeen() > bottomSeenId) {
                    this.scroll.unlockBottomSeen();
                    change = true;
                }
                if (change) {
                    this.scroll.checkPinBottom(function (pinBottom) {
                        this.onScrollChange(pinBottom);
                    }, this);
                }
            }
        } else {
            // Only set marker if last_seen_eid change happens while deselected
            this.updateLastSeen();
        }
    },
    focusChange: function () {
        if (!this.isVisible()) {
            return;
        }
        this.scroll.checkPinBottom(function (pinBottom) {
            if (this.model.session.isFocused()) {
                // Remove the focus marker
                this.scroll.unlockFocusSeen();
            } else {
                if (pinBottom) {
                    // Set the marker if scrolled to bottom
                    this.updateLastSeen();
                    // Unlock the bottom seen marker so we can take over
                    this.scroll.unlockBottomSeen();
                    this.scroll.log.removeBottomSeen();
                }
                this.scroll.lockFocusSeen();
            }
            this.onScrollChange(pinBottom);
        }, this);
    },
    onInput: function (e) {
        // Hide magic copy button
        this.selectionCopy.hide(true);

        this.renderInputStatus(e);

        // Highlight last message for reactions
        if (!this.initReplyHighlight()) {
            this.clearReplyHighlight();
        }

    },
    activateReplyHighlight: function (lock) {
        if (this.replyHighlight) {
            return true;
        } else {
            var last = this.model.messages.lastReplyable();
            if (last) {
                var lastLine = this.scroll.log.getVisibleLineStrict(last);
                if (!lastLine) {
                    var lastParts = this.previousVisibleReplyable(last);
                    last = lastParts[0];
                    lastLine = lastParts[1];
                }
                if (this.setReplyHighlight(last, lastLine, lock)) {
                    return true;
                }
            }
        }
    },
    initReplyHighlight: function () {
        if (!this.isVisible()) {
            return;
        }
        if (this.blockNextReplyHighlight) {
            this.blockNextReplyHighlight = false;
            return;
        }
        if (this.input.isReactionShortcut()) {
            var ret = this.activateReplyHighlight();
            if (ret !== undefined) {
                return ret;
            }
        } else if (this.input.lockedReplyTarget) {
            return true;
        }
    },
    cycleReplyHighlights: function (key) {
        if (!this.replyHighlightMessage) {
            return false;
        }
        var up = key == Keyboard.KEYS.UP;
        var down = key == Keyboard.KEYS.DOWN;
        this.scroll.inputInfo.hide();
        var message, messageLine, parts;
        if (up) {
            parts = this.previousVisibleReplyable(this.replyHighlightMessage);
        } else if (down) {
            parts = this.nextVisibleReplyable(this.replyHighlightMessage);
        }
        if (parts) {
            message = parts[0];
            messageLine = parts[1];
        }
        if (!message) {
            message = this.replyHighlightMessage;
            messageLine = this.scroll.log.getVisibleLineStrict(message);
        }
        if (this.setReplyHighlight(message, messageLine, true)) {
            this.scroll.scrollToMessage(message);
            return true;
        }
    },
    previousVisibleReplyable: function (message) {
        var m = message.previousReplyable();
        var mLine;
        while (m && !(mLine = this.scroll.log.getVisibleLineStrict(m))) {
            m = m.previousReplyable();
        }
        return [m, mLine];
    },
    nextVisibleReplyable: function (message) {
        var m = message.nextReplyable();
        var mLine;
        while (m && !(mLine = this.scroll.log.getVisibleLineStrict(m))) {
            m = m.nextReplyable();
        }
        return [m, mLine];
    },
    clearReplyHighlight: function (blockNext) {
        if (this.replyHighlight) {
            if (blockNext) {
                this.blockNextReplyHighlight = true;
            }
            this.replyHighlight.removeClass('addReplyHighlight');
            this.replyHighlight = null;
            this.replyHighlightMessage = null;
            this.input.replyTarget = null;
            this.input.lockedReplyTarget = false;
            this.unhoverReply();
        }
    },
    lockReplyHighlight: function (message) {
        if (message.equals(this.replyHighlightMessage)) {
            this.clearReplyHighlight();
        } else {
            this.setReplyHighlight(message, this.scroll.log.getVisibleLine(message), true);
            this.focusInput();
        }
    },
    setReplyHighlight: function (message, messageLine, lock) {
        if (message && messageLine) {
            this.clearReplyHighlight();
            messageLine.addClass('addReplyHighlight');
            this.hoverReply({target: messageLine});
            this.replyHighlightMessage = message;
            this.replyHighlight = messageLine;
            this.input.replyTarget = message;
            if (lock) {
                this.input.lockedReplyTarget = true;
            }
            return true;
        }
        return false;
    },
    getTemplate: function () {
        if (!BufferView._structure) {
            BufferView._structure = $($('#tpl-buffer').html());
        }
        return BufferView._structure.clone();
    },
    clickReply: function (e) {
        var row = $(e.target).closest('.row');
        var bufMessage = this.buffer.getMessage(row.data('eid'));
        if (bufMessage) {
            if (this.model.isThread()) {
                this.buffer.select();
                if (!this.buffer.isDeferred()) {
                    bufMessage.show();
                }
            } else {
                this.model.session.setThreadId(this.model.threadId(bufMessage.getReplyId()));
            }
        }
    },
    clickUpload: function (e) {
        this.model.session.trigger('clickUpload', e, this.model);
        return false;
    },
    clickEmoji: function (e) {
        this.model.session.trigger('clickEmoji', e, this.model);
        return false;
    },
    hoverReply: function (e) {
        var row = $(e.target).closest('.row');
        var reply = row.attr('data-reply');
        this.scroll.log.$('div.row').removeClass('hoverReply');
        if (reply) {
            var attr = '[data-reply="' + this.formatter.escapeQuerySelector(reply) + '"]';
            this.scroll.log.$('div.row' + attr).addClass('hoverReply');
        } else {
            row.addClass('hoverReply');
        }
        this.$el.addClass('hoveringReply');
    },
    unhoverReply: function () {
        if (this.replyHighlight) {
            this.hoverReply(({target: this.replyHighlight}));
        } else {
            this.$el.removeClass('hoveringReply');
            this.scroll.log.$('div.row').removeClass('hoverReply');
        }
    },
    render: function () {
        if (this.rendered) {
            return this;
        }
        this.firstRender = true;
        // This has a significant cost if done at initialisation time
        this.$el.attr({
            'role': 'tabpanel',
            'aria-labelledby': 'bufferlabel_' + this.model.bid()
        });
        debug.timeStamp(this.model.getTitle() + ' [render]');
        var structure = this.getTemplate();

        structure.find('div.viewport')
            .append(this.scroll.render().el)
            .append(this.scroll.stickyAvatarContainer)
            .append(this.scroll.clock.el)
            .append($('<div class="inputInfoWrapper">').append(this.scroll.inputInfo.el))
            .append(this.overlay.render().el);

        structure.find('.bufferstatus').append(this.status.render().el);
        this.status.postrender();

        structure.find('.upperchattercell').append(this.upperChatter.render().el);

        structure.find('.lowerchattercell').append(this.lowerChatter.render().el);

        structure.find('.connectionstatuscell').append(this.renderConnectionStatus(true).el);
        this.listenTo(this.model.connection, 'focusOnMakeBufferChange change:status change:fail_info change:away', function () {
            this.renderConnectionStatus();
        });

        this.timeCell = structure.find('.timecell');

        this.nickInputBox = structure.find('.nickinputcell');

        var lockTitle;
        if (this.model.connection.isSlack()) {
            lockTitle = "Private channel";
        } else {
            lockTitle = "Password protected";
        }
        structure.find('.lockcell .fa-lock').attr('title', lockTitle);

        if (this.nick) {
            this.nickBox = structure.find('.nickcell');
            this.nickBox.append(this.nick.render().el);
            this.nickBox.append('&nbsp;');
        }
        this.nickBoxShown = true;

        this.input.render();
        structure.find('.inputcell').append(this.input.el);

        this.selectionCopy.render();
        structure.find('.clipboardTriggerCell').append(this.selectionCopy.el);

        if (this.model.session.uploadsEnabled()) {
            this.upload.render();
            structure.find('.uploadcell').append(this.upload.radialProgress);
            structure.find('.uploadcell').append(this.upload.el);
        }

        this.input.on('input', this.onInput, this);
        this.input.on('completeCandidates', this.scroll.inputInfo.renderCandidates, this.scroll.inputInfo);

        this.scroll.on('makeInputChoice', function (index) {
            this.input.tabComplete.makeClickedChoice(index);
            this.focusInput();
        }, this);
        this.scroll.on('makeInputOriginalChoice', function () {
            this.input.tabComplete.makeOriginalChoice();
        }, this);

        this.renderActive();
        this.model.on('activeChange', this.renderActive, this);

        this.renderAway();
        this.listenTo(this.model.connection, 'change:away', this.renderAway);

        this.renderSlack();
        this.listenTo(this.model.connection, 'change:ircserver', this.renderSlack);
        this.listenTo(this.model.connection, 'change:hostname', this.renderSlack);

        this.$el.append(structure.children());

        if (this.postrender) {
            this.postrender();
        }

        this.focusInput();

        this.model.on('change:last_seen_eid', this.renderLastSeen, this);
        this.model.on('userTyping', this.userTyping, this);

        this.listenTo(this.model.session, 'prefChange:theme', function () {
            if (this.model.isSelected()) {
                this.onScrollChange();
            }
        });
        this.scroll.on('change', this.onScrollChange, this);
        setTimeout(_.bind(function renderScrollBindTimeout () {
            this.scroll.on('scroll', function bufferViewOnScroll (e, pinBottom) {
                var atBottom = this.scroll.isScrolledToBottom();
                if (pinBottom === undefined) {
                    this.scroll.updateScroll();
                }
                var manual;
                if (e && (!atBottom || !this.scroll.isScrolledToBottom())) {
                    manual = true;
                }
                this.doScroll(manual);
            }, this);
        }, this), 500);

        debug.timeStamp(this.model.getTitle() + ' [rendered]');

        this.model.trigger('rendered', this);

        this.rendered = true;

        return this;
    },
    doScroll: function (manual) {
        this.scroll.checkPinBottom(function (pinBottom) {
            var bottomSeen = this.model.getBottomSeen();
            if (pinBottom) {
                this.scroll.log.checkFlush();
                this.scroll.unlockBottomSeen();
                if (bottomSeen) {
                    pinBottom = false;
                }
            } else {
                this.scroll.lockBottomSeen();
            }

            // Run this first to update seen markers
            // before we get locked in fetch/rendering backlog
            this.onScrollChange(pinBottom, manual);
            
            this.scroll.checkInfiniscroll();
        }, this);
    }
});


module.exports = BufferView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferview.js
// module id = uiw5
// module chunks = 1